import banner from '../images/banner-2-1920x1080.jpg';
import '../styles/homepage.css';

const HomePage = () => {
    return (
        <div className='banner'>
            <img src={banner} alt='banner__image' className='banner__image'/>
            <div className='banner__info'>
                The Biliteracy Mapping Tool may be utilized for 
                support with the implementation of dual language 
                programs. The intent of these tools is to provide 
                planning and instruction support to dual language 
                teachers and educators. Here you will find links to 
                each tool resource along with an explanation of each 
                tools components.
            </div>
        </div>
    );
};

export default HomePage;
